export default "__VITE_ASSET__B9cGqV0j__"